/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type IntegrationsNumberGetSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type IntegrationsNumberGetRequest = {
  /**
   * The ID of the integration to get (refers to a package id).
   */
  id?: string | undefined;
  /**
   * The name of the integration to get (refers to a package name).
   */
  name?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type IntegrationsNumberGetSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const IntegrationsNumberGetSecurity$outboundSchema: z.ZodMiniType<
  IntegrationsNumberGetSecurity$Outbound,
  IntegrationsNumberGetSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function integrationsNumberGetSecurityToJSON(
  integrationsNumberGetSecurity: IntegrationsNumberGetSecurity,
): string {
  return JSON.stringify(
    IntegrationsNumberGetSecurity$outboundSchema.parse(
      integrationsNumberGetSecurity,
    ),
  );
}

/** @internal */
export type IntegrationsNumberGetRequest$Outbound = {
  id?: string | undefined;
  name?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const IntegrationsNumberGetRequest$outboundSchema: z.ZodMiniType<
  IntegrationsNumberGetRequest$Outbound,
  IntegrationsNumberGetRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    name: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function integrationsNumberGetRequestToJSON(
  integrationsNumberGetRequest: IntegrationsNumberGetRequest,
): string {
  return JSON.stringify(
    IntegrationsNumberGetRequest$outboundSchema.parse(
      integrationsNumberGetRequest,
    ),
  );
}
